import papaparse from 'papaparse'
import { UserRoles } from '@/lib/userRoles'
import { USERS_IMPORT, USERS_IMPORT_CHECK } from '@/store/actions/users'
import { mapState } from 'vuex';

export default {
  name: 'user-install',
  components: {},
  props: [],
  data () {
    return {
      userRoles: UserRoles,
      Papa: papaparse,
      config: {
        header: false
      },
      csv: null,
      step: 0,
      CSVerrors: [],
      data: [],
      roles: [
        { value: UserRoles.office, text: this.$t('message.User.roles.' + UserRoles.office) },
        { value: UserRoles.guidelinesAndPublicationsCouncil, text: this.$t('message.User.roles.' + UserRoles.guidelinesAndPublicationsCouncil) },
        { value: UserRoles.committeeUser, text: this.$t('message.User.roles.' + UserRoles.committeeUser) },
        { value: UserRoles.nationalDelegate, text: this.$t('message.User.roles.' + UserRoles.nationalDelegate) },
        { value: UserRoles.external, text: this.$t('message.User.roles.' + UserRoles.external) },
      ],
      available: null,
    }
  },
  computed: {
    ...mapState({
      dataLoading: state => state.users.status === 'loading',
    }),
  },
  mounted () {
    this.checkImportPossibility();
  },
  methods: {
    parseCSV() {
      let csv = this.Papa.parse(this.csv, this.config);
      
      this.CSVerrors = csv.errors;

      if (this.CSVerrors.length == 0) {
        this.formatData(csv.data);        
        this.step = 2;
      }
    },

    formatData(data) {
      this.data = [];

      data.forEach((elem) => {
        let row = {
          role: this.parseRole(elem[0]),
          first_name: elem[1],
          last_name: elem[2],
          email: elem[3],
          committee: elem[4],
        };

        this.data.push(row);
      });
    },

    parseRole(value) {
      let role;
      switch (value) {
        case 'Committee User':
          role = UserRoles.committeeUser;
          break;

        case 'National Delegate':
          role = UserRoles.nationalDelegate;
          break;

        case 'Admin':
          role = UserRoles.office;
          break;

        case 'Guidelines and Publications Council':
          role = UserRoles.guidelinesAndPublicationsCouncil;
          break;

        case 'External':
          role = UserRoles.external;
          break;
      }

      return role;
    },

    importUsers() {
      this.$validator.validate().then(result => {
        if (result) {
          this.$store.dispatch(USERS_IMPORT, {users: this.data, admin: this.admin}).then((response) => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.User.usersWasImported"),
              type: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              this.checkImportPossibility();
            })
          }).catch((error) => {
            this.handleUnauth(error.response.status);
            this.handleForbidden(error.response.status);
            this.handleUnprocessable(error.response);
          });
        }
      });
    },

    toCSVstep() {
      this.$validator.validate().then(result => {
        if (result) {
          this.step = 1;
        }
      });
    },

    checkImportPossibility() {
      this.$store.dispatch(USERS_IMPORT_CHECK).then((response) => {
        this.available = response.data.available;
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
        this.handleUnprocessable(error.response);
      });
    }
  }
}